module.exports = __webpack_public_path__ + "img/collection-weddingRingsGold.7089118.webp";